<template>
  <!-- w -19 h -11 -->
  <path d="M0 1.5H5" stroke="currentColor" stroke-width="2"/>
  <path d="M0 9.5H5" stroke="currentColor" stroke-width="2"/>
  <path d="M8 1.5H19" stroke="currentColor" stroke-width="2"/>
  <path d="M8 9.5H19" stroke="currentColor" stroke-width="2"/>
</template>
